<template>
    <el-drawer
        title="编辑模块"
        :visible.sync="show"
        :wrapperClosable="false"
        direction="rtl"
        size="40%"
        :before-close="close">
        <div class="panel fx-g1" >
            <el-tabs v-model="activeTab" class="fx-g1 fx-col inner_tags-page">
                 <el-tab-pane label="训练模块" name="saveExam">
                    <el-form ref="form" :model="form" label-width="150px" class="edit_form">
                        <el-form-item label="封面">
                            <el-upload
                                class="photo_uploader"
                                action=""
                                :show-file-list="false"
                                :before-upload="uploadBackgroundImg">
                                <img v-if="form.imgPath != null" :src="form.imgPath" class="avatar">
                                <i v-else class="el-icon-plus uploader-icon"></i>
                            </el-upload>
                            <el-button type="primary" size="small" @click="showBanner()">从总部图库添加</el-button>
                        </el-form-item>
                        <el-form-item label="标题" v-check="{'必填': !form.title}">
                            <el-input v-model="form.title"></el-input>
                        </el-form-item>
                        <el-form-item label="类型" v-check="{'必选': !form.type}">
                            <el-select v-model="form.type" clearable placeholder="类型">
                                <el-option
                                    v-for="item in types"
                                    :key="item.optionValue"
                                    :label="item.optionText"
                                    :value="item.optionValue">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="编程语言" v-check="{'必选': !form.optType}">
                            <el-select v-model="form.optType" placeholder="编程语言">
                                <el-option
                                    v-for="item in commLessonTypes"
                                    :key="item.optionValue"
                                    :label="item.optionText"
                                    :value="item.optionValue">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <!-- <el-form-item label="设置知识点">
                            <el-cascader placeholder="任务知识点筛选" style="width:400px;"
                                v-model="knowledgeIds" clearable
                                :options="options"
                                :props="{expandTrigger: 'hover',
                                multiple: true
                                }"
                                :show-all-levels="false"
                                @change="handleChange"></el-cascader>
                        </el-form-item> -->
                        <el-form-item label="分类" v-check="{'必选': !form.categoryId}">
                            <el-select v-model="form.categoryId" clearable placeholder="分类">
                                <el-option
                                    v-for="item in trainCategorys"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                            <el-form-item label="标签" v-check="{'必选': !form.tagIds,'必选': form.tagIds.length == 0}">
                            <el-select v-model="form.tagIds"  multiple clearable placeholder="标签">
                                <el-option
                                    v-for="item in trainTags"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="任务描述" v-check="{'必填': !form.content}">
                            <el-input type="textarea" v-model="form.content"></el-input>
                        </el-form-item>
                        <el-form-item label="难度" v-check="{'必须是数字': isNaN(form.difficulty)}">
                            <el-input-number v-model="form.difficulty"  :min="1" :max="5"  label=""></el-input-number>
                        </el-form-item>
                    </el-form>
                </el-tab-pane>
                <el-tab-pane label="总部图库" name="addBanner" v-if="bannerShow">
                    <el-table
                        ref="bannerTable"
                        :data="bannerLib"
                        style="width: 100%;overflow: auto;"
                    >
                        <el-table-column
                            type="radio"
                            width="55">
                             <template slot-scope="scope">
                                <el-radio v-model="radio" :label="scope.row.id" @change="handlePicChoose(scope.row)">{{''}}</el-radio>
                             </template>
                        </el-table-column>
                        <el-table-column
                            min-width="460px"
                            label="" >
                            <template slot-scope="scope">
                                <img :src="scope.row.value" style="width: 500px; height: 220px">
                            </template>
                        </el-table-column>
                    </el-table>
                </el-tab-pane>

            </el-tabs>
        </div>
        <span  class="fx fx-center">
            <el-button type="primary" @click="sub()">保 存</el-button>
            <el-button @click="close()">关 闭</el-button>
        </span>
    </el-drawer>
</template>
<style scoped>
</style>
<script>
    export default {
        props: [
            "item",
        ],
        components: {
        },
        data() {
            return {
                show: false,
                needRefreshParent: false,
                form: {...this.item,
                    tagIds: this.item.tagArray ? this.item.tagArray : []
                    //, knowledgeIds: (this.item.knowledgeIds ? this.item.knowledgeIds.split(",") : [])
                },
                showLoading: false,
                trainCategorys:[],
                trainTags:[],
                types:[],
                knowledgeIds:[],
                commLessonTypes:[],
                options: [],
                activeTab: 'saveExam',
                bannerLib:[],
                radio: '',
                bannerShow: false,
            }
        },


        methods: {
            showBanner() {
                this.bannerShow = true;
                this.activeTab = 'addBanner';
            },
            sub() {
                if(this.activeTab == 'addBanner'){
                    this.activeTab = 'saveExam';
                    this.bannerShow = false;
                }else{
                    this.$checkForm(this.$refs.form).then(success => {
                        if (success) {
                            //校验通过，干什么....
                            this.$ajaxPost("/trainModule/save", {
                                trainModule: {...this.form,
                                tagIds: this.form.tagIds.length > 0 ? this.form.tagIds.join(",") : null
                                //,knowledgeIds:this.knowledgeIds  ? this.knowledgeIds.join(","):null
                                }
                            }, (data) => {
                                this.$emit("submit", data.result);
                                this.showLoading = false;
                                this.needRefreshParent = true;
                                this.$showSuccess("保存成功");

                            })
                            return false;
                        } else {
                            this.$showError("请输入内容再保存");
                        }
                    })
                }
            },
            handlePicChoose(item) {
                this.form.imgPath = item.value;
            },
            close() {
                if (this.needRefreshParent) {
                    this.$emit("submit");
                } else {
                    this.$emit("close");
                }
            },
            selectable(row, index) {
                return row.canChoose;
            },
            uploadBackgroundImg(file) {
                this.$uploadQiniu(file, "trainModule/", {
                        success: (file) => {
                            this.form = Object.assign({}, this.form, {imgPath: file.url});
                        }
                    }
                )
                return false;
            },
            loadTrainCategory() {
                this.$ajaxGet("/trainCategory/listOptionByAll/1", (data) => {//listOptionBySchool
                     this.trainCategorys = data.result;
                })
            },
            loadTrainTag() {
                this.$ajaxGet("/trainCategory/listOptionByAll/2", (data) => {//listOptionBySchool
                     this.trainTags = data.result;
                })
            },
            loadType() {
                this.$ajaxGet("/common/trainModuleType", (data) => {
                     this.types = data.result;
                })
            },
            // loadFuncs() {
            //     this.$ajaxPost("/knowledge/knowledgeByTask",{form:{type:this.form.optType}} , (data) => {
            //         this.options = data.result;
            //     })
            // },
            // loadFuncs1() {
            //     this.$ajaxPost("/knowledge/knowledgeByTask",{form:{type:this.form.optType}} , (data) => {
            //         this.options = data.result;
            //     })
            // },
            // handleChange(value) {
            //     console.log(value);
            // },
             loadCommLessonTypes() {
                this.$ajaxGet("/common/lessonTypeByExamQuestion", (data) => {
                    this.commLessonTypes = data.result;
                })
            },
            loadBannerData() {
                //加载总部图库
                this.$ajaxGet("/dictionary/listCenterBannerLib/5", data => {
                    this.bannerLib = data.result;
                })
            }
        },
        mounted() {
            this.show = true;
        },
        created() {
            this.loadTrainCategory();
            this.loadTrainTag();
            this.loadType();
            this.loadCommLessonTypes();
            this.loadBannerData();
            // if(this.item.id > 0){
            //     this.loadFuncs();
            //     if(this.item.knowledgeListIds.length > 0){
            //         this.item.knowledgeListIds.forEach(item => {
            //             this.knowledgeIds.push(item.split(","));
            //         });
            //     }
            // }
        }


    }
</script>
